import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ReportsPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Reports
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Generate and view custom SEO performance reports.
        </Typography>
        {/* Reports components will be added here */}
      </Box>
    </Container>
  );
};

export default ReportsPage;